module.exports = __webpack_public_path__ + "static/media/TP_Icon_BallCap.7a23209b.png";